import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { ApplyFilter } from "@coworker/apprestructured/src/shared/filters/types/apply";
import { Article, Combined } from "../types/article";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";
import { EDS_DATES_ID } from "./useEdsDatesSelectArticleFilter";

export const ALERT_ID = "alert";

function useAlertSelectFilter() {
  const { t } = useTranslation();
  const defaultValue = { filterId: ALERT_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: ALERT_ID,
      title: t("alertsFilterTitleString"),
      options: [
        {
          value: "eds",
          title: t("edsString"),
          dependentOfFilterId: EDS_DATES_ID,
        },
        {
          value: "pastEds",
          title: t("pastEdsString"),
          dependentOfFilterId: EDS_DATES_ID,
        },
        { value: "salesStop", title: t("salesStopString") },
      ],
      enabled: true,
      defaultValue,
    },
    t("allArticlesString")
  );
}

function useAlertSelectArticleFilter() {
  const filter: ApplyFilter<SelectFilter, Article> = {
    filter: useAlertSelectFilter(),
    filterCompare: (item: Combined<Article>, { value }: FilterValue) => {
      switch (value) {
        case "eds":
          return item.eds && item.eds.validToDate
            ? item.eds.validToDate.getTime() >= new Date().getTime()
              ? true
              : false
            : false;
        case "pastEds":
          return item.eds && item.eds.validToDate
            ? item.eds.validToDate.getTime() < new Date().getTime()
              ? true
              : false
            : false;
        case "salesStop":
          return item.salesStop ? true : false;
        default:
          return true;
      }
    },
  };

  return filter;
}

export { useAlertSelectArticleFilter };
